var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"marquee-view text-center",attrs:{"align":"center","justify":"center"}},_vm._l((_vm.sponsors),function(s){return _c('v-col',{key:s.name},[_c('a',{attrs:{"href":s.link,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.getSrc(s.img)}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }